import ResetPasswordFeature from "./../features/ResetPassword";

export default function ResetPassword() {
  return <ResetPasswordFeature />;
}
